import { NgClass } from '@angular/common';
import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  EStatusBadgeExtraCategory,
  EWorkflow,
  EWorkflowIcon,
  TStatusBadgeCategory,
} from '../../../pages/items/items.interface';

const CATEGORY_ICON: Record<TStatusBadgeCategory, string> = {
  [EWorkflow.todo]: EWorkflowIcon.adjust,
  [EWorkflow.inProgress]: EWorkflowIcon.schedule,
  [EWorkflow.done]: EWorkflowIcon.task_alt,
  [EStatusBadgeExtraCategory.late]: 'error_outline',
  [EStatusBadgeExtraCategory.paused]: 'pause_circle_outline',
};

@Component({
  imports: [MatIcon, NgClass, TranslateModule],
  selector: 'app-status-category-badge',
  standalone: true,
  styleUrl: './status-category-badge.component.scss',
  templateUrl: './status-category-badge.component.html',
})
export class StatusCategoryBadgeComponent {
  public readonly statusCategory: InputSignal<TStatusBadgeCategory> = input.required<TStatusBadgeCategory>();

  /** Optional label override. When omitted, the translated status-category name is shown. */
  public readonly label: InputSignal<string | undefined> = input<string>();

  public readonly icon: Signal<string> = computed(() => CATEGORY_ICON[this.statusCategory()] ?? EWorkflowIcon.adjust);
}
